import React from 'react';
import RicosViewer from '../../../ui/ricos-viewer/ricos-viewer';
import { getHeaderAndParagraphCustomStylesWUT, getHeaderVariantCustomStylesWUT, useRicosTheme } from '../../../theme/ricos-theme-utils';
import { useTruncateRicosContent } from '../../../ui/ricos-viewer/use-truncate-ricos-content';
import { ToggleTruncateButtonWUT } from '../../../ui/ricos-viewer/toggle-truncate-button-wut';
import { useExperiments } from '../../../contexts/experiments-context';
import { EXPERIMENTS } from '../../../constants';
export const HeaderWUT = _ref => {
  let {
    content,
    maxShownParagraphs,
    id,
    FieldLayout
  } = _ref;
  const {
    isExperimentEnabled
  } = useExperiments();
  const isHeadingLevelsEnabled = isExperimentEnabled(EXPERIMENTS.ENABLE_HEADING_LEVELS);
  const customStyles = React.useMemo(() => isHeadingLevelsEnabled ? {
    ...getHeaderAndParagraphCustomStylesWUT(),
    ...getHeaderVariantCustomStylesWUT()
  } : getHeaderAndParagraphCustomStylesWUT(), [isHeadingLevelsEnabled]);
  const customTheme = useRicosTheme({
    customStyles
  });
  const {
    displayedContent,
    isTruncated,
    isTruncateButtonShown,
    toggleTruncate
  } = useTruncateRicosContent(content, maxShownParagraphs);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(RicosViewer, {
    content: displayedContent,
    customTheme: customTheme
  }), isTruncateButtonShown && /*#__PURE__*/React.createElement(ToggleTruncateButtonWUT, {
    isTruncated: isTruncated,
    onClick: toggleTruncate
  }));
};
//# sourceMappingURL=header-wut.js.map